__turbopack_context__.v({
  "banner": "PlasmicFeaturesTopSection-module__XTLORq__banner",
  "col": "PlasmicFeaturesTopSection-module__XTLORq__col",
  "img": "PlasmicFeaturesTopSection-module__XTLORq__img",
  "sectionHeader": "PlasmicFeaturesTopSection-module__XTLORq__sectionHeader",
  "subtitle": "PlasmicFeaturesTopSection-module__XTLORq__subtitle",
  "title": "PlasmicFeaturesTopSection-module__XTLORq__title",
  "top": "PlasmicFeaturesTopSection-module__XTLORq__top",
  "top2": "PlasmicFeaturesTopSection-module__XTLORq__top2",
  "wrapper": "PlasmicFeaturesTopSection-module__XTLORq__wrapper",
});
